import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from '../css/AddInvoice.module.css';
import { FaArrowLeft } from 'react-icons/fa6';

const AddInvoice = () => {
	const navigate = useNavigate();
	const { order_number } = useParams();
	const [error, setError] = useState('');

	const [formData, setFormData] = useState({
		description: '',
		qty: '',
		amount: '',
		date: '',
		paymentMethod: '',
		paymentStatus: '',
	});

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const agentId = localStorage.getItem('user_id');

		if (!agentId) {
			setError('Error: Agent ID not found. Please log in again.');
			return;
		}

		if (Object.values(formData).some((field) => !field)) {
			setError('Please fill in all fields.');
			return;
		}

		const invoiceData = {
			booking_id: order_number,
			Agent_id: agentId,
			description: formData.description,
			qty: formData.qty,
			amount: formData.amount,
			date: new Date(formData.date).toLocaleDateString('en-GB'),
			payment_method: formData.paymentMethod,
			payment_status: formData.paymentStatus,
		};

		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/AddInvoice.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(invoiceData),
				}
			);

			const text = await response.text();

			try {
				const result = JSON.parse(text);
				if (result.status) {
					setError('Invoice added successfully!');
					navigate(`/invoices/${order_number}`);
				} else {
					setError('Error: ' + result.msg);
				}
			} catch {
				console.error('Invalid JSON response:', text);
				setError('Server error: Invalid response format.');
			}
		} catch (error) {
			console.error('Error submitting invoice:', error);
			setError('Network error: Could not reach the server.');
		}
	};

	return (
		<div className={styles.container}>
			<button onClick={() => navigate(-1)} className={styles.backButton}>
				<FaArrowLeft size={20} color="black" />
			</button>
			<h2 className={styles.title}>Add Invoice</h2>
			<p>{error}</p>
			<form onSubmit={handleSubmit} className={styles.form}>
				<input
					type="text"
					name="description"
					placeholder="Description"
					value={formData.description}
					onChange={handleChange}
					className={styles.input}
				/>
				<input
					type="number"
					name="qty"
					placeholder="Quantity"
					value={formData.qty}
					onChange={handleChange}
					className={styles.input}
				/>
				<input
					type="number"
					name="amount"
					placeholder="Amount"
					value={formData.amount}
					onChange={handleChange}
					className={styles.input}
				/>
				<input
					type="date"
					name="date"
					value={formData.date}
					onChange={handleChange}
					className={styles.input}
				/>
				<select
					name="paymentMethod"
					value={formData.paymentMethod}
					onChange={handleChange}
					className={styles.input}
				>
					<option value="">Select Payment Method</option>
					<option value="Cash">Cash</option>
					<option value="Online">Online</option>
				</select>
				<select
					name="paymentStatus"
					value={formData.paymentStatus}
					onChange={handleChange}
					className={styles.input}
				>
					<option value="">Select Payment Status</option>
					<option value="Paid">Paid</option>
					<option value="Unpaid">Unpaid</option>
				</select>
				<button type="submit" className={styles.button}>
					Submit
				</button>
			</form>
		</div>
	);
};

export default AddInvoice;
